import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'antd';
import { useHistory } from 'react-router-dom';

import { routes } from '@/router';
import { useLang } from '@/hooks';

function NeedAuthModal(): JSX.Element {
  const showNeedAuthModal = useSelector((st) => st.user.showNeedAuthModal);
  const { user: { setShowNeedAuthModal } } = useDispatch();
  const history = useHistory();
  const { getTranslation, keys } = useLang();

  const onCancel = () => {
    setShowNeedAuthModal(false);
  };

  const onOk = () => {
    setShowNeedAuthModal(false);
    history.push(routes.logIn.path);
  };

  return (
    <Modal
      visible={showNeedAuthModal}
      onCancel={onCancel}
      onOk={onOk}
      title={getTranslation(keys.need_authorization_title)}
    >
      <p>{getTranslation(keys.need_authorization_text)}</p>
    </Modal>
  );
}

export default NeedAuthModal;
